module.exports = __webpack_public_path__ + "img/download-apple.b39ba52a.svg";